import { required } from './required';
export var validatePrice = function (value) {
    return value && !/^\d+(\.\d\d)?$/.test(value)
        ? 'Enter a valid price, e.g. 10 or 5.49'
        : null;
};
export var requiredPrice = required(validatePrice);
//# sourceMappingURL=validatePrice.js.map